import styled from "styled-components";
import Width from "../Width";
import { Helmet } from "react-helmet-async";
import React from "react";
import { Stack } from "@mui/material"; // Import directly
import HeaderUser from "../HeaderUser";
import LanguageSwitcher from "../LanguageSwitcher";

const HeaderBlock = styled.div`
  width: 100%;
  height: 100px;
  border-bottom: 1px solid #d1d3d4;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.div`
  background: url(/images/am/logo.svg);
  width: 200px;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50%;
`;

const HeaderComponent = () => {
  return (
    <HeaderBlock>
      <Helmet>
        <link rel="icon" href="/images/am/favicon.ico" />
      </Helmet>

      <Width>
        <Stack direction="row" alignItems="center" width="100%" height="100%">
          <Logo />

          <Stack
            marginLeft="auto"
            direction="row"
            alignItems="center"
            spacing={2}
          >
            <LanguageSwitcher />
            <HeaderUser />
          </Stack>
        </Stack>
      </Width>
    </HeaderBlock>
  );
};

export default HeaderComponent;
